import PropTypes from 'prop-types';
import React from 'react';
import { ugcRatingShape } from '@bibliocommons/bc-prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindAll } from '@bibliocommons/utils-react';
import { RatingControl } from '@bibliocommons/rating';

export class UserRatingDropdown extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleUpdateRating(rating) {
    if (this.props.userRating) {
      return this.props.ratingsActions.changeItemRating(this.props.metadataId, rating);
    }

    return this.props.ratingsActions.rateItem(this.props.metadataId, rating);
  }

  handleRemoveRating() {
    return this.props.ratingsActions.removeItemRating(this.props.metadataId, this.props.userRating.get('id'));
  }

  handleSelect(rating) {
    if (rating > 0) {
      this.handleUpdateRating(rating);
    } else {
      this.handleRemoveRating();
    }
  }

  render() {
    const { metadataId, userRating, ratingsTransactions, size, useLibraryBranding } = this.props;
    const rating = userRating ? userRating.get('rating') : 0;
    const isLoading = ratingsTransactions.getIn([metadataId, 'isLoading'], false);

    return (
      <RatingControl
        className="cp-user-rating-dropdown"
        handleSelect={this.handleSelect}
        rating={rating}
        isLoading={isLoading}
        size={size}
        useLibraryBranding={useLibraryBranding}
      />
    );
  }
}

UserRatingDropdown.propTypes = {
  metadataId: PropTypes.string.isRequired,
  userRating: ugcRatingShape,
  ratingsActions: PropTypes.objectOf(PropTypes.func),
  ratingsTransactions: ImmutablePropTypes.map.isRequired,
  size: PropTypes.oneOf(['default', 'extra-extra-small', 'extra-small', 'small', 'medium', 'large']),
  useLibraryBranding: PropTypes.bool
};

export default UserRatingDropdown;
